export class modulePathService {
    constructor(public localStorageService, public $http, private MyConstant, private $q) {
        "ngInject"

    }

    // get(module) {
    //     return this.getFromServer().then(
    //         response => {
    //             return response[module]
    //         }
    //     )
    // }

    get() {
        let cdv = this.localStorageService.get('cdv') || 1;
        let modulePath = this.localStorageService.get('modulePath')
        let path = this.$q((resolve, reject) => {
            if (modulePath && modulePath.cdv == cdv) {
                resolve(modulePath)
            }
            else {
                this.$http.get(`${this.MyConstant.ApiUrl}Settings/GetSettings`, { cache: true }).then(
                    response => {
                        response.data.ModulePath.cdv = this.localStorageService.get('cdv') || 1;
                        this.localStorageService.set('modulePath', response.data.ModulePath)
                        resolve(response.data.ModulePath)
                    },
                    error => {
                        reject(error)
                    }
                )

            }
        })


        return path
    }


}


// WEBPACK FOOTER //
// ./src/services/modulePath/modulePath.ts